import Phaser from 'phaser';

/*

    So here's the deal...

    Phaser SUCKS when it comes down to pausing, in that it pauses everything
    But the global pause it too damn handy to ignore :)

    so we extend the button and add out own pause functionality  ;)

*/
export default class DefaultButton extends Phaser.Button {
  constructor({ game, id, x, y, up, over, down, texture = 'buttons_sprite' }) {
    super(game, x, y, texture);

    this.id = id;
    this.setFrames(over, up, down, up);
    this.enable();
    this.useHandCursor = true;

    // pause/resume overrides
    this.game.onPause.add(this.onGamePaused, this);
    this.game.onResume.add(this.onGameResumed, this);

    //
    this.onInputDown.add(this.handleInputDown, this);

    // bind methods so we can clean up listeners
    this.bindedHandlePausedMouseMove = this.handlePausedMouseMove.bind(this);
    this.bindedHandlePausedMouseDown = this.handlePausedMouseDown.bind(this);

    // if the game is already paused, handle it :)
    if (this.game.paused) {
      this.onGamePaused();
    }

    // set default sfx
    this.sfx = { spriteID: 'general_audio', audioID: 'click' };
  }

  // add this functionalty so we can apply a consistent rule for custom buttons
  enable() {
    this.inputEnabled = true;
  }

  disable() {
    this.inputEnabled = false;
  }

  setSfx({ spriteID, audioID }) {
    this.sfx.audioID = audioID;
    this.sfx.spriteID = spriteID;
  }

  handleInputDown() {
    this.game.sounds.playSpriteSFX(this.sfx.audioID, { spriteID: this.sfx.spriteID });
  }

  /*
  =======================================================
    MANAGE BUTTON ON GAME PAUSE
  =======================================================
  */

  onGamePaused() {
    if (this.inputEnabled) {
      // set paused mouse flag to false
      this.pausedMouseOver = false;
      // attack mouse move and down listeners
      this.game.canvas.addEventListener('mousemove', this.bindedHandlePausedMouseMove);
      this.game.input.onDown.add(this.handlePausedMouseDown, this);
      // call method for safety wipe ;)
      this.bindedHandlePausedMouseMove();
    }
  }

  onGameResumed() {
    // clean up stuff :)
    this.pausedMouseOver = false;
    this.game.canvas.removeEventListener('mousemove', this.bindedHandlePausedMouseMove);
    this.game.input.onDown.remove(this.handlePausedMouseDown, this);
  }

  handlePausedMouseMove() {
    // make sure button is enabled
    if (this.inputEnabled) {
      // check for mouse over button bounds
      let mouseOver = this.isWithinBounds(this.game.input.x, this.game.input.y);

      // check these don't match so we don't continue firing
      if (this.pausedMouseOver != mouseOver) {
        // calling phaser 'internal methods' to override behaviour :)
        if (mouseOver) {
          this.onInputOverHandler(this, this.game.input.mousePointer);
        } else {
          this.onInputOutHandler(this, this.game.input.mousePointer);
        }
        // set flag to save consistent updates
        this.pausedMouseOver = mouseOver;
      }
    }
  }

  handlePausedMouseDown() {
    // make sure button is enabled
    if (this.inputEnabled) {
      // check for mouse over button bounds
      let mouseOver = this.isWithinBounds(this.game.input.x, this.game.input.y);
      // calling phaser 'internal methods' to override behaviour :)
      if (mouseOver) {
        this.onInputDownHandler(this, this.game.input.mousePointer);
      }
      this.pausedMouseOver = mouseOver;
    }
  }

  isWithinBounds(x, y) {
    return this.getBounds().contains(x, y);
  }

  destroy() {
    this.onGameResumed();
    this.onInputDown.remove(this.handleInputDown, this);
    this.game.onPause.remove(this.onGamePaused, this);
    this.game.onResume.remove(this.onGameResumed, this);
    this.disable();
    super.destroy(true);
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/buttons/DefaultButton.js